import { render } from "./force-2fa.vue?vue&type=template&id=3fe0ce8d"
import script from "./force-2fa.vue?vue&type=script&lang=js"
export * from "./force-2fa.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/force-2fa.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fe0ce8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fe0ce8d', __exports__)) {
    console.log('reload')
    api.reload('3fe0ce8d', __exports__)
  }
  
  module.hot.accept("./force-2fa.vue?vue&type=template&id=3fe0ce8d", () => {
    console.log('re-render')
    api.rerender('3fe0ce8d', render)
  })

}


export default __exports__